import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M4 6.03L11.5 9.25L4 8.25V6.03ZM11.5 14.75L4 17.97V15.75L11.5 14.75ZM2 3V10L17 12L2 14V21L23 12L2 3Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "CampaignsOutline"
);
